import { Alert } from 'components/common'
import clsx from 'clsx'
import { useEffect, useState } from 'react'

interface errorAlertProps {
  alertDescription: string[]
  onCloseAlert: () => void
  type?: 'error' | 'success' | 'info' | 'warning'
  message?: React.ReactNode
}

export const ErrorAlert = ({
  alertDescription,
  onCloseAlert,
  type,
  message,
}: errorAlertProps): JSX.Element => {
  const [alertType, setAlertType] = useState<'error' | 'success' | 'info' | 'warning'>('error')
  const [alertMessage, setAlertMessage] = useState<React.ReactNode>('エラー')
  useEffect(() => {
    if (type) {
      setAlertType(type)
    }
    if (message) {
      setAlertMessage(message)
    }
  }, [type, message])

  return (
    <>
      <Alert
        className={clsx('mb-5')}
        message={alertMessage}
        description={
          <div>
            {alertDescription?.length > 0 &&
              alertDescription?.map((value, index) => (
                <p key={`${value}${index}`}>{index > 0 ? `${index + 1}: ${value}` : `${value}`}</p>
              ))}
          </div>
        }
        type={alertType}
        showIcon
        closable
        onClose={onCloseAlert}
      />
    </>
  )
}
